import { Form } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { CustomFloatingLabel } from "./customfloatinglabel.jsx";
import { StyledTextArea } from "./base/styledtextarea.jsx";
import { FormGroup } from "./common.js";

export const FormInput = ({
  name,
  label,
  formGroupProps,
  inputProps,
  required,
  disabled,
  customErrorMessage,
  additionalClassnames,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required }}
      render={({
        field: { value, onChange, disabled: globalDisabled, onBlur, ref },
        fieldState: { error, isDirty },
      }) => {
        const errorType = error?.type;

        const helperText = () => {
          if (errorType === "required") {
            return "The field is required";
          }
          return errorType && customErrorMessage?.[errorType] ? customErrorMessage[errorType] : error?.message;
        };

        return (
          <FormGroup required={required} className={additionalClassnames} {...formGroupProps}>
            <CustomFloatingLabel label={`${label} ${required ? " *" : ""}`}>
              <StyledTextArea
                name={name}
                value={value}
                onChange={onChange}
                as="input"
                type="text"
                required={required}
                rows={4}
                $active={isDirty}
                onBlur={onBlur}
                disabled={disabled || globalDisabled}
                ref={ref}
                $inputRef={ref}
                {...inputProps}
              />
            </CustomFloatingLabel>
            {error && (
              <Form.Control.Feedback type="invalid" className="d-block mb-1">
                {helperText()}
              </Form.Control.Feedback>
            )}
          </FormGroup>
        );
      }}
    />
  );
};
